import {useState, useEffect} from 'react'; 
import { Search, Menu, X, ArrowLeft, ExternalLink } from 'lucide-react';
import styles from './AreasProfesionales.module.css'; 
import { useNavigate } from 'react-router-dom';
import {useAuth} from '../../../Auth/AuthContext'; 

const Carreras = () => { 
    const navigate = useNavigate();
    const [activeDropdown, setActiveDropdown] = useState(null); 
    const [searchTerms, setSearchTerms] = useState('');
    const [selectedInfo, setSelectedInfo] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); 
    const [areasProfesionales, setAreasProfesionales] = useState([]); 
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const {getToken} = useAuth();
    const token = getToken(); 

    //Obtenemos las universidades y carreras. 
    useEffect (() => { 
        const fetchCarreras = async () => { 
            try { 
                const response = await fetch(`${process.env.REACT_APP_API_URL}/universidades/obtener-carreras`, { 
                    headers: { 
                        'Authorization': `Bearer ${token}`
                    }
                }); 
                if (!response.ok) { 
                    throw new Error('Error al obtener las carreras');
                }
                const data = await response.json(); 
                setAreasProfesionales(data); 
                setLoading(false);
            } catch (err) { 
                setError(err.message); 
                setLoading(false); 
            }
        };
        fetchCarreras(); 
    }, []); 
    

    const navigateTo = (route) => {
        navigate(route);
    };

    const toggleDropdown = (dropdownId) => { 
        setActiveDropdown(activeDropdown === dropdownId ? null : dropdownId); 
    };

    const handleSearch = (areaId, term) => { 
        setSearchTerms(prev => ({ ...prev, [areaId]: term})); 
    }; 

    const selectCareer = (career) => { 
        setSelectedInfo(career); 
        setActiveDropdown(null); 
    }; 

    const filterCareers = (careers, searchTerm) => { 
        if (!searchTerm) return careers; 
        return careers.filter(career =>
            career.name.toLowerCase().includes(searchTerm.toLowerCase())
        ); 
    }; 

    const toggleMobileMenu = () => { 
        setIsMobileMenuOpen(!isMobileMenuOpen); 
    }; 

    // Nueva función para abrir la página de la universidad
    const openUniversityWebsite = (universityUrl) => {
        if (universityUrl) {
            // Verificar si la URL ya tiene protocolo
            const url = universityUrl.startsWith('http://') || universityUrl.startsWith('https://') 
                ? universityUrl 
                : `https://${universityUrl}`;
            
            // Abrir en nueva ventana
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    };

    if (loading) {
        return (
            <div className={styles.loadingContainer}>
                <div className={styles.loadingContent}>
                    <div className={styles.loadingSpinner}></div>
                        <p className={styles.loadingText}>Cargando carreras...</p>
                    </div>
                </div>
            );
    }

    return (
        <div className={styles.pageContainer}>

            {/* Mobile Menu Toggle */}
            <button 
                onClick={toggleMobileMenu}
                className={styles.mobileMenuToggle}
            >
                {isMobileMenuOpen ? <X /> : <Menu />}
            </button>

            {/* Main Content */}
            <main className={styles.mainContent}>

            <h1 className={styles.pageTitle}>
                Inventario de áreas profesionales y carreras
            </h1>
            
            <p className={styles.description}>
                Tomando en cuenta tus resultados del test de intereses profesionales, selecciona el área que te corresponde
                para que puedas conocer las carreras universitarias que se ofertan en el estado de Querétaro.
                <br /><br />
                Selecciona el botón del área profesional para acceder al listado de carreras.
            </p>

            {/* Dropdown Container */}
            <div className={styles.dropdownContainer}>
                {areasProfesionales.map((area) => (
                <div key={area.id} className={styles.dropdownWrapper}>
                    <button
                    onClick={() => toggleDropdown(area.id)}
                    className={styles.areaButton}
                    >
                    {area.title}
                    </button>

                    {activeDropdown === area.id && (
                    <div className={styles.dropdownContent}>
                        <div className={styles.searchContainer}>
                        <Search className={styles.searchIcon} />
                        <input
                            type="text"
                            placeholder="Buscar carrera..."
                            value={searchTerms[area.id] || ''}
                            onChange={(e) => handleSearch(area.id, e.target.value)}
                            className={styles.searchInput}
                        />
                        </div>

                        {filterCareers(area.careers, searchTerms[area.id]).map((career, index) => (
                        <button
                            key={index}
                            onClick={() => selectCareer(career)}
                            className={styles.careerItem}
                        >
                            {career.name}
                        </button>
                        ))}
                    </div>
                    )}
                </div>
                ))}
            </div>

            {selectedInfo && (
                <div className={styles.infoBox}>
                <h3 className={styles.infoTitle}>{selectedInfo.name}</h3>
                <div className={styles.universityList}>
                    {selectedInfo.universities.map((university, index) => (
                    <div 
                        key={index} 
                        className={`${styles.universityItem} ${university.pagina ? styles.clickableUniversity : ''}`}
                        onClick={() => university.pagina && openUniversityWebsite(university.pagina)}
                        style={{ cursor: university.pagina ? 'pointer' : 'default' }}
                        title={university.pagina ? `Visitar ${university.name}` : ''}
                    >
                        <img src={`${process.env.REACT_APP_API_URL}/universidades/logos-universidades/${university.logo}`} className={styles.universityLogo} />
                        <span>{university.name}</span>
                        {university.pagina && (
                            <ExternalLink className={styles.externalLinkIcon} size={16} />
                        )}
                    </div>
                    ))}
                </div>
                </div>
            )}
            </main>
        </div>
        );
}; 

export default Carreras;